import { io } from "socket.io-client";
import { getAuthToken } from "utils/auth";

export const AIAssistantSocketClient = io(process.env['REACT_APP_COLLECTIONS_AGENT_SOCKET_URL'], {
    autoConnect: false,
    reconnection: true,
    transports: ['websocket'],
    query: {
        token: getAuthToken()
    }
});